import { Component, useState } from 'react';
import Page from '../../containers/page';

import {
    Button,
    Container,
    FormGroup,
    Label,
    Modal,
    ModalBody,
    ModalFooter,
    Row,
} from 'reactstrap';

import Isvg from 'react-inlinesvg'

import ListBuilder from '../../components/listBuilder';
import { getSearchParams, generateSearchLink, generateSearchLinkMultiple } from '../../helpers/linkHelper';
import { API_ENDPOINT, JOURNAL_DASHBOARD } from '../../constants';
import { formValueSelector, change } from 'redux-form';  // ES6
import { connect } from 'react-redux';
import viewIcon from '../../assets/svg/eye.svg';
import editIcon from '../../assets/svg/edit.svg';
import LockIcon from '../../assets/svg/lock.svg';
import pdfIcon from '../../assets/svg/save-as-pdf.svg';

import PreviewModal from '../../components/previewModal';
import InfoModal from '../../components/infoModal';

import { JOURNAL_API } from '../../constants';
import { getParamsFromURL, updateParamsHelper } from '../../helpers/custom.helper';
import ListCheckBox from '../../components/forms/fields/listCheckboxFlex';
import ErrorModal from '../../components/errorModal';
import { isClinicAdminChecker } from '../../helpers/journal.helper';

function parseText(response) {
    return response.text().then(text => {
        return {
            result: text,
            status: response.status
        }
    })
}
class JournalNotesPage extends Component {
    constructor(props) {
        super(props);

        this.state = {

            ...props.initialData,
            _isMounted: false,
            useState: false,
            params: {
                entries: 10,
                page: 0
            },
            journalNotes: [],
            notesFilter: 'unsigned',
            journalSSOToken: null,

            loadingProfessions: false,
            professionsList: [],
            professionsValues: [],

            iframeReady: false,
            pendingAppData: null,
            clinicUserPermissions: null
        };

        this.wholeRowClickable = true;
    }

    getProfessions = async () => {
        if (!this.state._isMounted) return;

        this.setState({
            loadingProfessions: true,
            professionsList: [],
        })

        try {
            const response = await fetch(
                `${API_ENDPOINT}/users/users/patient/journalTemplates/workersCategories/get`,
                {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${localStorage.getItem('authToken')}`,
                    },
                    body: JSON.stringify({
                        groupId: this.props.selectedGroup || null,
                    }),
                }
            );

            const data = await response.json();

            if (data) {
                const newState = {
                    loadingProfessions: false,
                    professionsList: data,
                };

                this.setState(newState);
            } else {
                const errState = { loadingProfessions: false };
                if (data.error) { errState.error = data.error }

                this.setState(errState);
            }
        } catch (err) {
            this.setState({
                loadingProfessions: false,
                error: err?.message || 'Error fetching professions',
            });
        }
    }

    getClinicUserData = async () => {
        try {
            const response = await fetch(`${API_ENDPOINT}/journal-curoflow/clinic-user/get-permission`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${localStorage.getItem('authToken')}`,
                },
                body: JSON.stringify({ groupId: this.props.selectedGroup }),
            });

            const result = await response.json();

            this.setState({ clinicUserPermissions: result?.data?.permissions });
        } catch (err) {
            console.log('Err get clinic user data', err);
        }

    }

    get = async () => {
        if (!this.state._isMounted) return;
        this.setState({
            loading: true,
            journalNotes: [],
            modified: 'Not modified'.translate(this.props.lang),
        });

        const sortField = {
            'initialCreatedAt': 'initialCreatedAt',
            'templateName': 'templateData.templateName',
            // 'templateType': 'templateData.templateType',
            'doctorName': 'doctorData.doctorName',
        }

        try {

            const response = await fetch(
                `${API_ENDPOINT}/users/users/patient/journalNotes/get-all`,
                {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${localStorage.getItem('authToken')}`,
                    },
                    body: JSON.stringify({
                        groupId: this.props.selectedGroup || null,
                        clinicId: this.props.selectedClinic || null,
                        entries: this.state.params?.entries,
                        page: this.state.params?.page,
                        filter: this.state.params?.filter ?? '',
                        status: this.state.notesFilter,
                        professions: this.state.professionsValues || [],
                        sortField: sortField[this.state.params?.sortField] || 'initialCreatedAt',
                        sortType: this.state.params?.sortType,
                    }),
                }
            );

            const { data } = await response.json();

            if (data?.items) {
                const newState = {
                    loading: false,
                    journalNotes: data?.items,
                    total: data?.total,
                };

                if (data?.tsModified) {
                    const modified = this.props.getStringDateTs?.(
                        data?.tsModified,
                        this.props.dateFormat
                    );
                    if (modified) newState.modified = modified.translate(this.props.lang);
                }

                this.setState(newState);
            } else {
                const errState = {
                    loading: false,
                    modified: 'Not modified'.translate(this.props.lang),
                };

                if (data?.error) {
                    errState.error = data.error;
                }

                this.setState(errState);
            }
        } catch (err) {
            this.setState({
                loading: false,
                error: err?.message || 'Error fetching journal notes',
            });
        }
    }

    getJournalSSOToken = async (type = "notes") => {
        try {
            const response = await fetch(
                `${API_ENDPOINT}/users/users/patient/journal/getJournalTokenSSO`,
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${localStorage.getItem("authToken")}`,
                    },
                    body: JSON.stringify({ type, groupId: this.props.selectedGroup || null }),
                }
            );

            const data = await response.json();

            if (!response.ok || data?.error) {
                throw new Error(data?.error || "SSO token error");
            }

            return data;
        } catch (err) {
            console.error("SSO token fetch error", err);
            return null;
        }
    };
    formatJournalNoteDateTimeLocal = (value) => {
        if (!value) {
            const d = new Date();
            const pad = n => String(n).padStart(2, '0');

            return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
        }

        const REGEX = /^\d{4}-\d{2}-\d{2} \d{2}:\d{2}$/;

        if (!REGEX.test(value)) {
            throw new Error('Invalid date format. Expected YYYY-MM-DD HH:mm');
        }

        return value.replace(' ', 'T');
    };

    signJournalNote = async (item, status) => {
        await fetch(`${API_ENDPOINT}/users/users/patient/journalNotes/sign`, {
            method: 'PATCH',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${localStorage.getItem('authToken')}`,
            },
            body: JSON.stringify({
                status,
                groupId: this.props.selectedGroup || null,
                journalNoteId: item._id,
                patientId: item.patientData.patientId,
                journalDate: this.state.journalDate ?? this.formatJournalNoteDateTimeLocal()
            }),
        }).then(parseText).then(({ status, result }) => {
            const res = JSON.parse(result);
            if (res.error) {
                this.setState({ error: res.error });
            }
        });

        this.setState({
            pdfModal: false,
            infoSignModal: false,
            infoUnsignModal: false,
            journalDate: null
        })

        this.get();
    }

    componentDidMount() {
        this.state._isMounted = true;

        this.getClinicUserData();

        this.getProfessions();

        const urlParams = getParamsFromURL();

        const newParams = {
            ...this.state.params,
            entries: urlParams.entries,
            filter: urlParams.filter,
        };

        this.setState({ params: newParams });

        if (this.props[0].location.state && this.props[0].location.state.notesFilter) {
            this.setState({
                notesFilter: this.props[0].location.state.notesFilter
            });
        }

        this.get();
        window.addEventListener("message", this.handleIframeResize);
        window.addEventListener("message", this.handleIframeMessage);
    }

    componentWillUnmount() {
        this.state._isMounted = false;
        window.removeEventListener("message", this.handleIframeResize);
        window.removeEventListener("message", this.handleIframeMessage);
    }

    handleIframeResize = (event) => {
        // if (event.origin !== JOURNAL_DASHBOARD) return;
        if (event.data?.type === "IFRAME_V1_JOURNAL_TEMPLATES_BUILDER_HEIGHT_CHANGED") {
            const iframe = document.getElementById("journalNotesTabIframe");
            if (iframe) {
                // console.log('event.data?.payload?.height', event.data?.payload?.height)
                // if (event.data?.payload?.height <= 1000) {
                //     iframe.style.height = `${event.data?.payload?.height + 3 ?? 1003}px`;
                // } else {
                //     iframe.style.height = '1003px';
                // }
            }
        }
    };

    handleIframeMessage = (event) => {
        // if (event.origin !== JOURNAL_DASHBOARD) return;
        if (!event.data?.type) return;

        if (event.data.type === "IFRAME_READY_V1_JOURNAL_TEMPLATES_BUILDER") {
            this.setState({ iframeReady: true }, this.flushPendingAppData);
        }

        if (event.data.type === "IFRAME_CLOSE_V1_JOURNAL_NOTES_JOURNAL_TEMPLATES_MODAL") {
            this.closeModal();
        }
    };

    handleIframeLoad = () => {
        if (!this.state._isMounted) return;

        const payload = this.buildAppDataPayload();

        if (this.state.iframeReady) {
            this.postAppData(payload);
        } else {
            this.setState({ pendingAppData: payload });
        }
    };

    buildAppDataPayload = () => {
        const clinic = this.props.uData?.clinicGroups?.find(
            c => c._id === this.props.selectedGroup
        );

        this.props?.countryTwoLetter

        return {
            clinicId: clinic?.journalCuroflow?.clinicId,
            doctorId: this.props.uData?.journalCuroflow?.[String(this.props.selectedGroup)]?.id,
            patientId: this.state.patientJournalId,
            disableEdit: this.state.journalFormBuilder?.isSigned?.status === true ? true : this.checkDisableEdit(this.state.journalFormBuilder),
            disableSign: this.checkDisableEdit(this.state.journalFormBuilder),
            departmentId: this.props.selectedClinic,
            isClinicAdmin: isClinicAdminChecker(this.props),
            lang: this.props.lang || "en",
            countryTwoLetter: this.props?.countryTwoLetter || localStorage.getItem('countryTwoLetter'),
            curoflowV1: true
        };
    };

    postAppData = (payload) => {
        const iframe = document.getElementById("journalNotesTabIframe");
        if (!iframe?.contentWindow) return;

        iframe.contentWindow.postMessage(
            { type: "APP_DATA", payload },
            JOURNAL_DASHBOARD
        );
    };

    flushPendingAppData = () => {
        if (!this.state.pendingAppData) return;
        this.postAppData(this.state.pendingAppData);
        this.setState({ pendingAppData: null });
    };

    closeModal = () => {
        this.setState({
            journalFormBuilder: null,
            patientJournalId: null,
            iframeReady: false,
            pendingAppData: null
        }, () => {
            this.get();
        });
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps[0].location.search !== this.props[0].location.search) {
            this.setState({
                loading: true
            }, () => {
                this.get();

            })
        }

        if (prevProps.selectedClinic !== this.props.selectedClinic) {
            this.get();
        }

        if (prevState.professionsValues !== this.state.professionsValues) {
            this.get();
        }
    }


    // always copy - paste these updateSort, updateParams, updateMultipleParams
    updateSort = (field, type) => {
        updateParamsHelper(this, { sortField: field, sortType: type });
    };

    updateParams = (name, value, restart = false) => {
        updateParamsHelper(this, { [name]: value }, restart);
    };

    updateMultipleParams = (fields, restart = false) => {
        updateParamsHelper(this, fields, restart);
    };


    checkPermission = () => {
        let hasPermission = false;

        const clinic = this.props.uData?.clinicGroups?.find(c => c._id === this.props.selectedGroup);

        const groupPermissionsUser = this.props.uData?.groupPermissionsUser;
        const adminPermissionId = this.props.uData?.permissions?.clinicAdmin;
        const doctorPermissionId = this.props.uData?.permissions?.doctor;

        const isClinicAdmin = groupPermissionsUser?.[this.props.selectedGroup]?.[this.props.selectedClinic]?.indexOf(adminPermissionId) !== -1 ? true : false;
        const isDoctor = groupPermissionsUser?.[this.props.selectedGroup]?.[this.props.selectedClinic]?.indexOf(doctorPermissionId) !== -1 ? true : false;

        if (isClinicAdmin && clinic?.journalCuroflow?.allowAdminUnlockSignedNotes) {
            hasPermission = true;
        } else if (!isClinicAdmin && isDoctor && clinic?.journalCuroflow?.allowHealthcareProviderUnlockSignedNotes) {
            hasPermission = true;
        }

        return hasPermission;
    }
    checkDisableEdit = (item, skipLastSignedCheck) => {
        const clinic = this.props.uData?.clinicGroups
            ?.find(c => c._id === this.props.selectedGroup);

        const CONSENT_ACTIVE = this.props.isConsentActive;
        const CONSENT_SWITCH_ON = this.props.isConsentGrantedAndActive;

        const groupPermissionsUser = this.props.uData?.groupPermissionsUser;
        const adminPermissionId = this.props.uData?.permissions?.admin;
        const schedulerPermissionId = this.props.uData?.permissions?.scheduler;

        const isAdmin = groupPermissionsUser?.[this.props.selectedGroup]?.[this.props.selectedClinic]?.indexOf(adminPermissionId) !== -1 || groupPermissionsUser?.[this.props.selectedGroup]?.[this.props.selectedClinic]?.indexOf(schedulerPermissionId) !== -1 ? true : false;


        const ALLOW_HEALTHCARE_PROVIDER_UNLOCK_SIGNED_NOTES =
            clinic?.journalCuroflow?.allowHealthcareProviderUnlockSignedNotes;

        const ALLOW_ADMIN_UNLOCK_SIGNED_NOTES =
            clinic?.journalCuroflow?.allowAdminUnlockSignedNotes;

        const JOURNAL_NOTE = item ? item : this.state.journalFormBuilder;

        let disableEdit = false;

        if (!JOURNAL_NOTE) {
            disableEdit = false;
        } else {
            // if (CONSENT_ACTIVE && CONSENT_SWITCH_ON) {
            // 	disableEdit = true;
            // } else if (!CONSENT_ACTIVE || (CONSENT_ACTIVE && !CONSENT_SWITCH_ON)) {
            if (ALLOW_HEALTHCARE_PROVIDER_UNLOCK_SIGNED_NOTES === false && JOURNAL_NOTE?.isSigned?.status === true && !isAdmin) {
                disableEdit = true;
            } else if (ALLOW_ADMIN_UNLOCK_SIGNED_NOTES === false && JOURNAL_NOTE?.isSigned?.status === true && isAdmin && JOURNAL_NOTE?.doctorData?.doctorId !== this.props.uData?.journalCuroflow?.[this.props.selectedGroup]?.id) {
                disableEdit = true;
            } else if (JOURNAL_NOTE?.isSigned?.status === false && JOURNAL_NOTE?.doctorData?.doctorId !== this.props.uData?.journalCuroflow?.[this.props.selectedGroup]?.id) {
                disableEdit = true;
            } else {
                disableEdit = false;
            }

            if (ALLOW_HEALTHCARE_PROVIDER_UNLOCK_SIGNED_NOTES && JOURNAL_NOTE?.doctorData?.doctorId !== this.props.uData?.journalCuroflow?.[this.props.selectedGroup]?.id && !isAdmin) {
                disableEdit = true
            }

            if (isAdmin && JOURNAL_NOTE?.doctorData?.doctorId === this.props.uData?.journalCuroflow?.[this.props.selectedGroup]?.id) {
                disableEdit = false
            }
            // }
        }

        // if (!skipLastSignedCheck) {
        // 	if (JOURNAL_NOTE?.isSigned?.status === true) {
        // 		disableEdit = true;
        // 	}
        // }

        // if (!this.props.uData.journalCuroflow[this.props.selectedGroup]?.permissions?.writePatientJournalNotes) {
        //     disableEdit = true;
        // }

        if (!this.state.clinicUserPermissions?.write?.journal_notes) {
            disableEdit = true;
        }

        return disableEdit;
    };

    render() {
        let params = {};
        params = this.state.params;

        // const hasPermission = this.checkPermission();

        return (
            <div className={this.props.autoHideSidebar ? "dashboard dashboard-auto-hide" : "dashboard"}>



                <Container fluid>
                    <Row>
                        <div className='panel'>

                            <div className="panel-header" >
                                {/* <h5 className="component-header" style={{ whiteSpace: 'nowrap' }}>{'EHR Notes'.translate(this.props.lang)}</h5> */}
                                <h5 className="component-header mb-35">{this.props.linksMeta && this.props.linksMeta[this.props[0].location.pathname] ? this.props.linksMeta[this.props[0].location.pathname][this.props.lang] : ''}</h5>

                            </div>

                            <div style={{ marginBottom: 20 }}>
                                {/* <div className="profession-buttons">
                                    <div>
                                        <div >
                                            <button className={this.state.notesFilter === 'all' ? ' clicked' : ''} onClick={() => {
                                                this.setState({
                                                    notesFilter: 'all'
                                                }, () => this.get(), this.updateMultipleParams([{ name: 'page', value: '0' }, { name: 'entries', value: '10' }]))
                                            }} >{'All'.translate(this.props.lang)}</button>
                                        </div>
                                    </div>

                                    <div>
                                        <div style={{ marginLeft: 10 }}>
                                            <button className={this.state.notesFilter === 'signed' ? ' clicked' : ''} onClick={() => {
                                                this.setState({
                                                    notesFilter: 'signed'
                                                }, () => this.get(), this.updateMultipleParams([{ name: 'page', value: '0' }, { name: 'entries', value: '10' }]))
                                            }} >{'Signed'.translate(this.props.lang)}</button>
                                        </div>
                                    </div>

                                    <div>
                                        <div style={{ marginLeft: 10 }}>
                                            <button className={this.state.notesFilter === 'unsigned' ? ' clicked' : ''} onClick={() => {
                                                this.setState({
                                                    notesFilter: 'unsigned'
                                                }, () => this.get(), this.updateMultipleParams([{ name: 'page', value: '0' }, { name: 'entries', value: '10' }]))
                                            }} >{'Unsigned'.translate(this.props.lang)}</button>
                                        </div>
                                    </div>

                                </div>

                                <div style={{ marginTop: '10px' }}></div> */}

                                <ListCheckBox
                                    label={'Filter by professions:'.translate(this.props.lang)}
                                    value={this.state.professionsValues}
                                    buttonText1={'Mark all'.translate(this.props.lang)}
                                    buttonText2={'Unmark all'.translate(this.props.lang)}
                                    values={this.state.professionsList && this.state.professionsList.length > 0 ? this.state.professionsList.map(item => {
                                        return { name: this.props.lang == 'en' ? item.professionEn : item.professionSv, value: item._id }
                                    }) : null}
                                    onChange={(e) => {
                                        if (e && e.length) {
                                            let arr = [];
                                            arr = [...e]
                                            this.setState({ professionsValues: arr })
                                        } else {
                                            this.setState({ professionsValues: [] })
                                        }
                                    }}
                                />

                            </div>

                            <ListBuilder
                                lang={this.props.lang}
                                loading={this.state.loading}
                                total={this.state.total}
                                hideEntries={false}
                                showNumeration={false}

                                fields={[
                                    {
                                        type: 'text',
                                        name: 'initialCreatedAt',
                                        label: 'Created at'.translate(this.props.lang),
                                        allowSort: true,
                                    },
                                    {
                                        type: 'text',
                                        name: 'patientName',
                                        label: 'Patient'.translate(this.props.lang),
                                    },
                                    {
                                        type: 'text',
                                        name: 'patientSSN',
                                        label: 'Social security number'.translate(this.props.lang),
                                    },
                                    {
                                        type: 'text',
                                        name: 'templateName',
                                        label: 'Template name'.translate(this.props.lang),
                                        allowSort: true,
                                    },
                                    // {
                                    //     type: 'text',
                                    //     name: 'templateType',
                                    //     label: 'Template type'.translate(this.props.lang),
                                    //     allowSort: true,
                                    // },
                                    {
                                        type: 'text',
                                        name: 'doctorName',
                                        label: 'Clinician'.translate(this.props.lang),
                                        allowSort: true,
                                    },

                                ]}
                                items={this.state.journalNotes.map((item) => {
                                    return {
                                        ...item,
                                        patientName: `${item?.patientData?.patientName}`,
                                        doctorName: `${item?.doctorData?.doctorName}`,
                                        patientSSN: `${item?.patientData?.patientSSN}`,
                                        templateName: `${item?.templateData?.templateName}`,
                                        // templateType: `${item?.templateData?.templateType}`,
                                    };
                                })}
                                allowRowClick={true}
                                onClick={async (item) => {
                                    if (this.wholeRowClickable === false) return;
                                    const { data: tokenData } = await this.getJournalSSOToken("notes");
                                    if (!tokenData?.data?.token) return;

                                    this.setState({
                                        journalSSOToken: tokenData.data.token,
                                        patientJournalId: item.patientData.patientId,
                                        journalFormBuilder: item,
                                        iframeReady: false,
                                        pendingAppData: null,
                                    })
                                }}
                                actions={[
                                    {
                                        renderComponent: (item) => {
                                            // const disableEdit = item.isSigned.status === true ? true : !this.checkPermission();
                                            const disableEdit = this.checkDisableEdit(item);
                                            return (
                                                <div className='tabel-action-tooltip'>
                                                    {' '}
                                                    {disableEdit === false ? <Isvg src={editIcon} /> : <Isvg src={viewIcon} />}{' '}
                                                    <div className='chat-icons-tooltip'>
                                                        {disableEdit === false ? 'Edit'.translate(this.props.lang) : 'View'.translate(this.props.lang)}
                                                    </div>{' '}
                                                </div>
                                            )

                                        },
                                        onClick: async (item) => {
                                            this.wholeRowClickable = false;
                                            setTimeout(() => {
                                                this.wholeRowClickable = true;
                                            }, 500);
                                            const { data: tokenData } = await this.getJournalSSOToken("notes");
                                            if (!tokenData?.data?.token) return;

                                            this.setState({
                                                journalSSOToken: tokenData.data.token,
                                                patientJournalId: item.patientData.patientId,
                                                journalFormBuilder: item,
                                                iframeReady: false,
                                                pendingAppData: null,
                                            })
                                        },
                                        condition: (item) => {
                                            // let disableEdit = !this.checkPermission();
                                            const disableEdit = this.checkDisableEdit(item);

                                            if (!disableEdit) {
                                                return true;
                                            } else {
                                                return false;
                                            }
                                        }
                                    },
                                    {
                                        renderComponent: (item) => {
                                            // const hasPermission = this.checkPermission();
                                            const disableEdit = this.checkDisableEdit(item);

                                            return (
                                                <div className={item?.isSigned?.status === false ? 'tabel-action-tooltip' : 'tabel-action-tooltip svg-sign'}>
                                                    {' '}
                                                    <Isvg width={20} height={20} src={LockIcon} />{' '}
                                                    <div className='chat-icons-tooltip'>
                                                        {item?.isSigned?.status === false && this.props.uData?.journalCuroflow?.[this.props.selectedGroup]?.id === item?.doctorData?.doctorId ? 'Sign'.translate(this.props.lang) :
                                                            item?.isSigned?.status === true && disableEdit ? 'Unsign' :
                                                                'Signed'.translate(this.props.lang)}
                                                    </div>{' '}
                                                </div>
                                            )
                                        },
                                        onClick: (item) => {
                                            this.wholeRowClickable = false;
                                            setTimeout(() => {
                                                this.wholeRowClickable = true;
                                            }, 500);
                                            // const hasPermission = this.checkPermission();
                                            const disableEdit = this.checkDisableEdit(item);
                                            if (item?.isSigned?.status === false) this.setState({ infoSignModal: item })
                                            else if (item?.isSigned?.status === true && disableEdit) this.setState({ infoUnsignModal: item })
                                        },
                                        condition: (item) => {
                                            if ((item?.isSigned?.status === false && this.props.uData?.journalCuroflow?.[this.props.selectedGroup]?.id === item?.doctorData?.doctorId) || item?.isSigned?.status === true) {
                                                return true;
                                            } else {
                                                return false;
                                            }
                                        }
                                    },
                                    {
                                        component: (
                                            <div className='tabel-action-tooltip'>
                                                {' '}
                                                <Isvg width={20} height={20} src={pdfIcon} />{' '}
                                                <div className='chat-icons-tooltip'>
                                                    {'Save as pdf'.translate(this.props.lang)}
                                                </div>{' '}
                                            </div>
                                        ),
                                        onClick: async (item) => {
                                            this.wholeRowClickable = false;
                                            setTimeout(() => {
                                                this.wholeRowClickable = true;
                                            }, 500);
                                            const response = await fetch(`${API_ENDPOINT}/users/users/patient/journalNotes/pdf`, {
                                                method: 'post',
                                                headers: {
                                                    'Content-Type': 'application/json',
                                                    Authorization: `Bearer ${localStorage.getItem('authToken')}`,
                                                },
                                                body: JSON.stringify({ groupId: this.props.selectedGroup || null, id: item?._id, patientId: item?.patientData?.patientId, lang: this.props?.lang || "en" }),
                                                responseType: 'blob'
                                            })

                                            const blob = await response.blob();

                                            const url = window.URL.createObjectURL(blob);
                                            window.open(url, '_blank');

                                            setTimeout(() => window.URL.revokeObjectURL(url), 10000);
                                        },
                                    },
                                ]}
                                rawItems={this.state.items}
                                params={params}
                                sortField={params.sortField}
                                sortType={params.sortType}
                                updateSort={this.updateSort}
                                updateParams={this.updateParams}
                                updateMultipleParams={this.updateMultipleParams}
                            ></ListBuilder>



                        </div>
                    </Row>


                </Container>

                {
                    this.state.infoSignModal ?
                        // <InfoModal
                        //     isOpen={this.state.infoSignModal}
                        //     onClose={(item) => {
                        //         this.setState({
                        //             infoSignModal: false
                        //         })
                        //     }}
                        //     header={'Confirm Journal Note Signature'.translate(this.props.lang)}
                        //     info={'Signing will lock the note, and you will not be able to edit or delete it afterward. Do you want to sign?'.translate(this.props.lang)}
                        //     buttons={[
                        //         <Button color="primary" disabled={this.state.loadingAssign} style={{ margin: 10 }}
                        //             onClick={async () => {
                        //                 await this.signJournalNote(this.state.infoSignModal, true)
                        //                 await this.get();
                        //                 this.setState({ infoSignModal: false })
                        //             }}>{'Sign'.translate(this.props.lang)}</Button>,
                        //         <Button color="primary" style={{ margin: 10 }} onClick={() => this.setState({ infoSignModal: false })}>{'Cancel'.translate(this.props.lang)}</Button>
                        //     ]}
                        // />
                        <Modal isOpen={this.state.infoSignModal} centered>
                            <ModalBody>
                                <p>{'Signing will publish and lock this note. Signed notes cannot be deleted. To edit, you must un-sign it first.'.translate(this.props.lang)}</p>
                                {
                                    this.state.infoSignModal?.notesHistory?.length > 1 ? null :
                                        <div className="form-questions-builder__questions-header-date-datetime-wrap">
                                            <label>{"Signing date".translate(this.props.lang)}:</label>
                                            <input
                                                type="datetime-local"
                                                value={this.state.journalDate ?? this.formatJournalNoteDateTimeLocal(this.state.infoSignModal?.initialCreatedAt)}
                                                onChange={(e) => {
                                                    this.setState({
                                                        journalDate: e.target.value
                                                    })
                                                }}
                                                className="sign-note-modal__questions-header-date-datetime-input"
                                            />
                                        </div>
                                }



                            </ModalBody>
                            <ModalFooter className='buttons-right-blue'>
                                <Button color='primary' onClick={() => this.setState({ infoSignModal: null })}>{'Cancel'.translate(this.props.lang)}</Button>
                                <Button color='primary' onClick={async () => {
                                    await this.signJournalNote(this.state.infoSignModal, true)
                                    await this.get();
                                    this.closeModal();
                                }}>{'Sign note'.translate(this.props.lang)}</Button>
                            </ModalFooter>
                        </Modal>
                        :
                        null
                }

                {
                    this.state.infoUnsignModal ?
                        <InfoModal
                            isOpen={this.state.infoUnsignModal}
                            onClose={(item) => {
                                this.setState({
                                    infoUnsignModal: false
                                })
                            }}
                            header={'Confirm Journal Note Unsign'.translate(this.props.lang)}
                            info={'Do you want to unsign this note?'.translate(this.props.lang)}
                            buttons={[
                                <Button color="primary" disabled={this.state.loadingAssign} style={{ margin: 10 }}
                                    onClick={async () => {
                                        await this.signJournalNote(this.state.infoUnsignModal, true)
                                        await this.get();
                                        this.setState({ infoUnsignModal: false })
                                    }}>{'Unsign'.translate(this.props.lang)}</Button>,
                                <Button color="primary" style={{ margin: 10 }} onClick={() => this.setState({ infoUnsignModal: false })}>{'Cancel'.translate(this.props.lang)}</Button>
                            ]}
                        />
                        :
                        null
                }

                {
                    this.state.journalFormBuilder ?
                        <PreviewModal
                            lang={this.props.lang}
                            isOpen={this.state.journalFormBuilder}
                            toggle={() => this.closeModal()}
                            hideCloseButton={true}
                            className={"modal-xxxl"}
                        // beforeCloseButton={this.state.journalFormBuilder?.isSigned?.status === false && this.props.uData?.journalCuroflow?.[this.props.selectedGroup]?.id === this.state.journalFormBuilder?.doctorData?.doctorId ? [
                        //     <Button color='primary' onClick={async () => {
                        //         await this.signJournalNote(this.state.journalFormBuilder, true)
                        //         await this.get();
                        //         this.setState({ journalFormBuilder: false })
                        //     }} >
                        //         {'Sign'.translate(this.props.lang)}
                        //     </Button>
                        // ] : []}
                        >

                            {this.state.journalFormBuilder && this.state.journalSSOToken && this.state.patientJournalId && (
                                <iframe
                                    onLoad={this.handleIframeLoad}
                                    id="journalNotesTabIframe"
                                    // src={this.state.journalSSOToken ? `${JOURNAL_DASHBOARD}/journal/templates/builder/${this.state.journalFormBuilder?.templateData?.templateId}/${this.state.journalFormBuilder?._id}?token=${this.state.journalSSOToken}` : ''}
                                    src={`${JOURNAL_DASHBOARD}/journal/templates/builder/${this.state.journalFormBuilder?.templateData?.templateId}/${this.state.journalFormBuilder?._id}?token=${this.state.journalSSOToken}`}
                                    style={{ width: '100%', height: '70vh', border: '1px solid #fff' }}
                                />
                            )}

                        </PreviewModal>
                        :
                        null
                }
                {
                    this.state.error ?
                        <ErrorModal
                            isOpen={this.state.error ? true : false}
                            toggle={() => this.setState({ error: null })}
                        >
                            {
                                this.state.error.translate(this.props.lang)
                            }
                        </ErrorModal>
                        :
                        null
                }
            </div >
        );
    }
}

const selector = formValueSelector('modalForm');

export default connect(state => {
    return { group: selector(state, 'group') }

}, {
    changeSubgroup: value => change("modalForm", "subgroup", value),

})(Page(JournalNotesPage));
